import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  Injector,
  Input,
  NgZone,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { FederalAndState } from "../../result/result.component";
import { Answer } from "virtue-form";
import { TuiDialogService } from "@taiga-ui/core";
import { CollegeprofileComponent } from "../dialog/collegeprofile/collegeprofile.component";
import { PolymorpheusComponent } from "@tinkoff/ng-polymorpheus";
import { NgxTippyProps } from "ngx-tippy-wrapper";
import { PredefineArrayListService } from "src/app/core/services/shared/predefine-array-list.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { ApiService } from "src/app/core/services/shared/api.service";
import { IntrestPageAnswer } from "src/app/core/models/answerMapModel";

@Component({
  selector: "app-colleges-cart-view",
  templateUrl: "./colleges-cart-view.component.html",
  styleUrls: ["./colleges-cart-view.component.scss"],
})
export class CollegesCartViewComponent implements OnInit {
  @ViewChild("toggleButton") toggleButton: ElementRef;
  @ViewChild("menu") menu: ElementRef;
  CollegeSelctionList: Map<string, IntrestPageAnswer> = new Map();
  CollegeSelctionListNew: Map<string, IntrestPageAnswer> = new Map();
  @Input() universityList: any = [];
  maxUniversityListArr: any = [];
  selectedLabel: string = "";
  filled: boolean = false;
  showTitle: boolean = false;

  addWatchlistMemberOptions = [
    {
      value: "REACH",
      label: "REACH",
      checked: false,
    },
    {
      value: "TARGET",
      label: "TARGET",
      checked: false,
    },
    {
      value: "SAFETY",
      label: "SAFETY",
      checked: false,
    },
    // {
    //   value: "NONE",
    //   label: "None",
    //   checked: false,
    // },
  ];
  collegeCardViewList: any = [];
  isduplicateResidencyselected: boolean = false;
  @Input() ApproxoutofPocket: any = [];
  @Input() meritAmount: any = [];
  @Input() answerMap!: Map<Number, Answer>;
  universityData: any = [];
  year = new Date().getFullYear();
  collegeSortByList: any = [];
  collegeSortBy: string = this.globalvar.collegeSortBy;
  // collegeSortBy: string = this.predefineArray.collegeSortByList[1].value;
  public baseProps: NgxTippyProps = {
    arrow: true,
    theme: "light",
    delay: 500,
  };

  templateRef: NgxTippyProps = {
    ...this.baseProps,
    allowHTML: true,
    appendTo: "parent",
    interactive: true,
    interactiveBorder: 50,
  };
  passInnerHTML: NgxTippyProps = this.templateRef;
  closeTimeout: NodeJS.Timeout;
  constructor(
    private predefineArray: PredefineArrayListService,
    private cdr: ChangeDetectorRef,
    private globalvar: GlobalVarService,
    private zone: NgZone,
    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector,
    public apiService: ApiService,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private elem: ElementRef
  ) {
    // this.renderer.listen("window", "click", (e: Event) => {
    //   /**
    //    * Only run when toggleButton is not clicked
    //    * If we don't check this, all clicks (even on the toggle button) gets into this
    //    * section which in the result we might never see the menu open!
    //    * And the menu itself is checked here, and it's where we check just outside of
    //    * the menu and button the condition abbove must close the menu
    //    */
    //   if (
    //     e.target !== this.toggleButton.nativeElement &&
    //     e.target !== this.menu.nativeElement
    //   ) {
    //     this.showPopup = false;
    //   }
    // });
  }
  ngOnInit(): void {
    console.log(this.collegeCardViewList, "CoollegeCardViewList");
    console.log(this.universityList, "UniversityList");

    if (this.globalvar.CollegeSelctionList) {
      // Use optional chaining to access nested properties
      // this.CollegeSelctionListNew = this.globalvar.CollegeSelctionList;
      let maxUList = this.globalvar.CollegeSelctionList.get(
        "maxUniversityListArr"
      );

      // Make sure maxUList is not null or undefined before accessing its properties
      if (maxUList?.list) {
        this.maxUniversityListArr = maxUList.list;
      }
    }

    // this.addWatchlistMemberOptions.forEach((option) => {
    //   const matchingObjects = this.universityList.filter(
    //     (obj) => obj?.dropDownData?.activeList === option.value
    //   );

    //   option.checked = matchingObjects.length > 0; // Set to true if there is any matching object
    // });
    // let ArrayList = [];
    // ArrayList = this.universityList;

    let rankFilterAvailable = false;
    this.universityList.forEach((element, index) => {
      let outOfPocketCost = this.getOutOfPocketAmountSort(
        element?.dropDownData
      );
      this.universityList[index].dropDownData.outOfPocketCost = outOfPocketCost;
      if (element?.dropDownData?.collegeRankInUS) {
        rankFilterAvailable = true;
      }

      if (
        this.universityList[index]?.dropDownData?.result?.totalGrant?.amount
      ) {
        this.universityList[index].dropDownData.totalGrant =
          this.getMeritHeaderAmount1(
            this.universityList[index]?.dropDownData?.result?.totalGrant
              ?.amount,
            index
          );
      }
    });
    let sortList: any = [];
    sortList = JSON.stringify(this.predefineArray.cartViewCollegeSortByList);
    if (rankFilterAvailable) {
      this.collegeSortByList = JSON.parse(sortList);
    } else {
      this.collegeSortByList = JSON.parse(sortList);
      this.collegeSortByList.splice(0, 1);
    }

    this.sortCollegeData();
  }

  sortCollegeData() {
    let clgList = [];
    let collegeData = this.universityList;
    if (this.globalvar.collegeSortBy == "By_Rank") {
      let acsOrderClgDistance = [];
      let notAvailableClgDistance = [];

      collegeData.forEach((element) => {
        if (element?.dropDownData?.collegeRankInUS) {
          acsOrderClgDistance.push(element);
        } else {
          notAvailableClgDistance.push(element);
        }
      });

      acsOrderClgDistance.sort((a: any, b: any) => {
        let fa = a?.dropDownData?.collegeRankInUS,
          fb = b?.dropDownData?.collegeRankInUS;
        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }

        return 0;
      });

      collegeData = [...acsOrderClgDistance, ...notAvailableClgDistance];
    }

    if (this.globalvar.collegeSortBy == "By_Cost") {
      collegeData.sort((a: any, b: any) => {
        let fa = a?.dropDownData?.outOfPocketCost,
          fb = b?.dropDownData?.outOfPocketCost;
        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });
    }

    if (this.globalvar.collegeSortBy == "By_Grant") {
      collegeData.sort((a: any, b: any) => {
        let fa = a?.dropDownData?.totalGrant,
          fb = b?.dropDownData?.totalGrant;
        if (fa > fb) {
          return -1;
        }
        if (fa < fb) {
          return 1;
        }
        return 0;
      });
    }

    if (this.globalvar.collegeSortBy == "By_Alphabet_A_Z") {
      collegeData.sort((a: any, b: any) => {
        let fa = a?.dropDownData?.name.toLowerCase(),
          fb = b?.dropDownData?.name.toLowerCase();
        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });
    }
    if (this.globalvar.collegeSortBy == "By_Alphabet_Z_A") {
      collegeData.sort((a: any, b: any) => {
        let fa = a?.dropDownData?.name.toLowerCase(),
          fb = b?.dropDownData?.name.toLowerCase();
        if (fa > fb) {
          return -1;
        }
        if (fa < fb) {
          return 1;
        }
        return 0;
      });
    }

    this.collegeCardViewList = collegeData;
  }

  ChangeSorting(value: string) {
    this.collegeSortBy = value;
    this.globalvar.collegeSortBy = value;
    this.sortCollegeData();
  }
  duplicateresidency() {
    this.isduplicateResidencyselected = !this.isduplicateResidencyselected;
  }
  private openUniversitySummaryDialog = this.dialogService.open<any>(
    new PolymorpheusComponent(CollegeprofileComponent, this.injector),
    {
      data: "",
      dismissible: false,
      label: "ToolTip",
      // size: "auto",
    }
  );

  OpenUniversitySummaryDialog(university: any) {
    this.universityData = university;
    this.openUniversitySummaryDialog = this.dialogService.open<any>(
      new PolymorpheusComponent(CollegeprofileComponent, this.injector),
      {
        data: this.universityData,
        dismissible: false,
      }
    );
    this.openUniversitySummaryDialog.subscribe({
      next: (data: any) => {},
      complete: () => {},
    });
  }

  getbasedOnCollegeWebsiteAmount(clg: any) {
    let totalGrant = 0;
    let npcCOAAmt = 0;
    let basedOnCollegeWebsiteAmount = 0;

    if (
      clg?.dropDownData["result"]?.totalGrant?.amount ||
      clg?.summaryData?.basedOnCollegeWebsite
    ) {
      totalGrant =
        clg?.dropDownData["result"]?.totalGrant?.amount != undefined
          ? clg?.dropDownData["result"]?.totalGrant?.amount
          : 0;
      npcCOAAmt = clg?.summaryData?.basedOnCollegeWebsite
        ? clg?.summaryData?.basedOnCollegeWebsite
        : 0;
    }

    let affinityAmt = this.getAffinityAmount(
      clg?.dropDownData.yearWiseAffinityQuestion
    );
    if (affinityAmt) {
      totalGrant += affinityAmt;
    }

    let stateGrantData = clg?.dropDownData["result"]?.stateAid;
    let selectedStateCode = clg?.dropDownData?.StudentSelectedCollege;
    if (stateGrantData != undefined) {
      let grntAmt = Number(
        this.setStateAidandGrandAmount(stateGrantData, selectedStateCode)
      );
      totalGrant += grntAmt;
    }

    if ((npcCOAAmt || totalGrant) && npcCOAAmt > totalGrant) {
      basedOnCollegeWebsiteAmount = npcCOAAmt - totalGrant;
      // this.roundOfNumber(npcCOAAmt) - this.roundOfNumber(totalGrant);
    }
    return basedOnCollegeWebsiteAmount > 0 ? basedOnCollegeWebsiteAmount : 0;
  }

  setStateAidandGrandAmount(obj: FederalAndState, selectedState: any) {
    let statGrand = this.answerMap.get(99999);
    let studentState = this.answerMap.get(6);
    let collegeWiseStateCode =
      selectedState?.stateCode != undefined ? selectedState?.stateCode : "";
    //  if (obj.amount) {
    //   return obj.amount;
    // } else
    let collegeWiseStateGrant =
      selectedState?.universityWiseStateGrant.length > 0
        ? selectedState?.universityWiseStateGrant[0]?.amount
        : 0;
    if (obj.isEligible == true && obj.isIncluded != true) {
      if (collegeWiseStateGrant) {
        return collegeWiseStateGrant;
      } else if (
        studentState.value.toLowerCase() != "mn" &&
        studentState.value.toLowerCase() != "nj" &&
        collegeWiseStateCode.toLowerCase() == studentState.value.toLowerCase()
      ) {
        return statGrand != undefined ? statGrand.value : 0;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  getOutOfPocketAmountSort(clgData: any) {
    let costOfAttendanceAmount = 0;
    let meritScholarShipAmt = 0;
    let costofAttendanceList = clgData["npcCollegeCostProfile"];
    let meritScholerShipGrantList = clgData?.result?.totalGrant;
    if (meritScholerShipGrantList?.amount != undefined) {
      meritScholarShipAmt = meritScholerShipGrantList?.amount;
    }
    let affinityAmt = this.getAffinityAmount(clgData?.yearWiseAffinityQuestion);
    if (affinityAmt) {
      meritScholarShipAmt += affinityAmt;
    }
    let stateGrantData = clgData?.["result"]?.stateAid;
    let selectedStateCode = clgData?.StudentSelectedCollege;
    if (stateGrantData != undefined) {
      let grntAmt = Number(
        this.setStateAidandGrandAmount(stateGrantData, selectedStateCode)
      );
      meritScholarShipAmt += grntAmt;
    }
    for (let index = 0; index < costofAttendanceList.length; index++) {
      const row = costofAttendanceList[index];
      if (row.fieldNo == "50") {
        costOfAttendanceAmount = row.value;
      }
    }
    let outOfPocketCost = costOfAttendanceAmount - meritScholarShipAmt;
    return outOfPocketCost > 0 ? outOfPocketCost : 0;
  }
  // getOutOfPocketAmount(i: number) {
  //   let costOfAttendanceAmount = 0;
  //   let AffinityAmount = 0;
  //   let meritScholarShipAmt = 0;
  //   let costofAttendanceList =
  //     this.universityList[i].dropDownData["npcCollegeCostProfile"];
  //   let meritScholerShipGrantList =
  //     this.universityList[i].dropDownData?.result?.totalGrant;

  //   if (meritScholerShipGrantList?.amount != undefined) {
  //     meritScholarShipAmt = meritScholerShipGrantList?.amount;
  //   }

  //   let affinityAmt = this.getAffinityAmount(
  //     this.universityList[i]?.dropDownData?.yearWiseAffinityQuestion
  //   );
  //   if (affinityAmt) {
  //     meritScholarShipAmt += affinityAmt;
  //   }

  //   let stateGrantData =
  //     this.universityList[i]?.dropDownData["result"]?.stateAid;
  //   let selectedStateCode =
  //     this.universityList[i]?.dropDownData?.StudentSelectedCollege;
  //   if (stateGrantData != undefined) {
  //     let grntAmt = Number(
  //       this.setStateAidandGrandAmount(stateGrantData, selectedStateCode)
  //     );
  //     meritScholarShipAmt += grntAmt;
  //   }

  //   for (let index = 0; index < costofAttendanceList.length; index++) {
  //     const row = costofAttendanceList[index];
  //     if (row.fieldNo == "50") {
  //       costOfAttendanceAmount = row.value;
  //     }
  //   }

  //   let outOfPocketCost = costOfAttendanceAmount - meritScholarShipAmt;
  //   // this.roundOfNumber(costOfAttendanceAmount) - this.roundOfNumber(meritScholarShipAmt);

  //   return outOfPocketCost > 0 ? outOfPocketCost : 0;
  //   // return Math.abs(outOfPocketCost);
  // }
  getOutOfPocketAmount(college) {
    let objArr = [];
    let amount = 0;
    let outOfPocketCost = 0;

    if (college?.dropDownData["npcCollegeCostProfile"]) {
      objArr = college?.dropDownData["npcCollegeCostProfile"];
    }

    objArr.forEach((element) => {
      if (element.fieldNo === 50) {
        amount = element.value;
      }
    });

    outOfPocketCost = Math.max(
      0,
      amount - college?.dropDownData?.result?.totalGrant?.amount
    );

    return outOfPocketCost;
  }

  getAffinityAmount(yearWiseAffinity: any) {
    let AffinityAmount = 0;
    let yearWiseAffinityQuestion =
      this.checkAffinityYearWiseAvailable(yearWiseAffinity);
    if (yearWiseAffinityQuestion.length > 0) {
      if (
        yearWiseAffinityQuestion[0]?.AffinityQuestionSelectedAmount != undefined
      ) {
        AffinityAmount =
          yearWiseAffinityQuestion[0]?.AffinityQuestionSelectedAmount;
      }
    }

    return AffinityAmount;
  }

  getMeritHeaderAmount1(meritAmount: number, i: number) {
    let meritHearderAmount = 0;

    if (meritAmount != undefined && meritAmount != null) {
      meritHearderAmount += meritAmount;
    }

    let affinityAmt = this.getAffinityAmount(
      this.universityList[i]?.dropDownData?.yearWiseAffinityQuestion
    );
    if (affinityAmt) {
      meritHearderAmount += affinityAmt;
    }

    let stateGrantData =
      this.universityList[i]?.dropDownData["result"]?.stateAid;
    let selectedStateCode =
      this.universityList[i]?.dropDownData?.StudentSelectedCollege;
    if (stateGrantData != undefined) {
      let grntAmt = Number(
        this.setStateAidandGrandAmount(stateGrantData, selectedStateCode)
      );
      meritHearderAmount += grntAmt;
    }
    return meritHearderAmount;
  }

  checkAffinityYearWiseAvailable(yearWiseAffinityQuestion: any) {
    let yearWiseAffinity: any = [];

    if (yearWiseAffinityQuestion != undefined) {
      if (
        yearWiseAffinityQuestion &&
        yearWiseAffinityQuestion[this.year] != undefined
      ) {
        yearWiseAffinity = yearWiseAffinityQuestion[this.year];
      } else {
        if (
          yearWiseAffinityQuestion &&
          yearWiseAffinityQuestion[this.year - 1] != undefined
        ) {
          yearWiseAffinity = yearWiseAffinityQuestion[this.year - 1];
        }
      }
    }
    return yearWiseAffinity;
  }

  checkRowIndex(index: number) {
    if (index == 1 || index == 6) {
      return "row college-cd mb-4";
    } else {
      return "";
    }
  }

  getErrorInCollegeCost(item: any, i: string) {
    let bool = false;

    if (item?.dropDownData["IPEDSNPC"]?.NPC?.errorInCollegeCost == true) {
      bool = item?.dropDownData["IPEDSNPC"]?.NPC?.errorInCollegeCost;
    }

    return bool;
  }

  getCostOfAttendanceHeaderAmount1(item: any, i: string) {
    let objArr = [];
    let amount = 0;

    if (item?.dropDownData["npcCollegeCostProfile"]) {
      objArr = item?.dropDownData["npcCollegeCostProfile"];
    }

    objArr.forEach((element) => {
      if (element.fieldNo == 50) {
        amount = element.value;
      }
    });
    return amount;
  }
  checkOutStateGridData(item: any, index: string) {
    let outStateGridNotUsed = false;
    let preferOutStateGrid = false;
    let val = false;

    if (item.dropDownData?.result?.preferOutStateGrid != undefined) {
      preferOutStateGrid = item.dropDownData?.result?.preferOutStateGrid;
    }
    let meritName = item.dropDownData?.result?.institutionalGrants;
    Object.keys(meritName).forEach((key) => {
      if (meritName[key]?.outStateGridUsed != undefined) {
        outStateGridNotUsed =
          meritName[key]?.amount > 0 &&
          meritName[key]?.outStateGridUsed == false &&
          preferOutStateGrid == true
            ? true
            : false;

        if (outStateGridNotUsed) {
          val = outStateGridNotUsed;
        }
      }
    });

    return val;
  }

  getFirstAndLastWords(str) {
    let result = "";
    const words = str.split("-");
    if (words.length >= 2) {
      const zeroindexvalue = words[0];
      const space = zeroindexvalue.split(" ");
      let lastElement = space[space.length - 1];
      result = words[0].charAt(0) + lastElement.charAt(0);
      return result;
    } else {
      const firstLetters = str.split(" ");
      let lastElement = firstLetters[firstLetters.length - 1];
      result = words[0].charAt(0) + lastElement.charAt(0);
    }
    return result;
  }
  // private openAddWatchList = this.dialogService.open<any>(
  //   new PolymorpheusComponent(AddWatchListComponent, this.injector),
  //   {
  //     data: "",
  //     dismissible: false,
  //     label: "ToolTip",
  //     size: "s",
  //   }
  // );
  // AddWatchList(ipedsId: any) {
  //   this.openAddWatchList = this.dialogService.open<any>(
  //     new PolymorpheusComponent(AddWatchListComponent, this.injector),
  //     {
  //       data: ipedsId,
  //       dismissible: false,
  //     }
  //   );
  //   this.openAddWatchList.subscribe({
  //     next: (data: any) => {},
  //     complete: () => {},
  //   });
  // }

  isFilled = false;
  showPopup = false;
  selectedLeveltext: string = "";
  selectedCollegeIndex: number;
  // openPopup(ipedsId: any, index: number) {
  //   const indexofipeds = this.universityList.findIndex(
  //     (college) => college?.dropDownData?.ipedsId === ipedsId
  //   );

  //   if (indexofipeds !== -1) {
  //     // Toggle the popup state for the specific item
  //     this.universityList[indexofipeds].showPopup =
  //       !this.universityList[indexofipeds].showPopup;

  //     // Set the selectedCollegeIndex based on the showPopup state
  //     this.selectedCollegeIndex = this.universityList[indexofipeds].showPopup
  //       ? index
  //       : null;

  //     // Log for debugging
  //     console.log("After toggle:", this.universityList[indexofipeds].showPopup);
  //     console.log("Selected index:", this.selectedCollegeIndex);
  //   } else {
  //     // If the item is not found, close the popup
  //     this.closePopup();
  //   }
  // }

  // // Additional method to close the popup and reset the selected index
  // closePopup() {
  //   this.universityList.forEach((college) => {
  //     college.showPopup = false;
  //   });
  //   this.selectedCollegeIndex = null;

  //   // Log for debugging
  //   console.log("Popup closed");
  // }
  openPopup(ipedsId: any, index: number, event: any) {
    event.stopPropagation();
    const indexofipeds = this.universityList.findIndex(
      (college) => college?.dropDownData?.ipedsId === ipedsId
    );

    if (indexofipeds !== -1) {
      this.showPopup = true;
      this.selectedCollegeIndex = index;
    } else {
      this.showPopup = false;
    }
  }
  cancelClose() {
    clearTimeout(this.closeTimeout); // Clear the timeout when mouse enters the dropdown
  }

  closePopup() {
    //  event.stopPropagation();
    this.showPopup = false;
    this.selectedCollegeIndex = null;
  }
  selectedCollegeIndexIpeds: number;
  SelectedColleeges: any[] = [];
  selectedCollegeLevels: { [Ipeds: string]: string } = {};

  selectLevel(event: any, level: string, Ipeds: any, index: number) {
    if (event.target.checked) {
      const indexofipedsselectofmaxUniversityList =
        this.maxUniversityListArr.findIndex(
          (college) => college?.ipedsId === Ipeds
        );

      if (indexofipedsselectofmaxUniversityList !== -1) {
        this.maxUniversityListArr[
          indexofipedsselectofmaxUniversityList
        ].wishList = level;

        const ans = {
          defaultLabel: "",
          defaultValue: "",
          list: this.maxUniversityListArr,
          wishList: "",
        };

        this.globalvar.CollegeSelctionList.set("maxUniversityListArr", ans);
      }
      if (level === "REACH" || level === "TARGET" || level === "SAFETY") {
        this.selectedCollegeIndexIpeds = index;

      }

      this.apiService.top5UserSubmission(
        this.globalvar.formSubmitId,
        this.maxUniversityListArr,
        this.globalvar.AddWatchList?.submissionReportLink,
        this.globalvar.AddWatchList,
        (resp) => {
          if (resp) {
          }
        }
      );

      // }
    } else {
      this.showPopup = false;
    }
  }
  


  isSelected(level: string, clg: any): boolean {
    const indexofmaxArray = this.maxUniversityListArr.findIndex(
      (college) => college?.ipedsId === clg?.dropDownData?.ipedsId
    );

    if (
      indexofmaxArray !== -1 &&
      this.maxUniversityListArr[indexofmaxArray]?.wishList === level
    ) {
      return true;
    } else {
      return false;
    }
  }
  selectedText(clg: any): string | undefined {
    const indexofmaxArray = this.maxUniversityListArr.findIndex(
      (college) => college?.ipedsId === clg?.dropDownData?.ipedsId
    );

    if (indexofmaxArray !== -1) {
      return this.maxUniversityListArr[indexofmaxArray]?.wishList;
    }

    // If ipedsId is not found, return undefined or any default value you prefer
    return undefined;
  }

  FillHeartColor(clg: any): string {
    const indexofmaxArray = this.maxUniversityListArr.findIndex(
      (college) => college?.ipedsId === clg?.dropDownData?.ipedsId
    );

    if (
      indexofmaxArray !== -1 &&
      this.maxUniversityListArr[indexofmaxArray]?.wishList !== undefined
    ) {
      const wishList = this.maxUniversityListArr[indexofmaxArray]?.wishList;

      // Map wishList values to corresponding CSS classes
      const classMap = {
        REACH: "reach-color",
        TARGET: "target-color",
        SAFETY: "safety-color",
        // Add more mappings as needed
      };

      // Return the corresponding CSS class based on wishList value
      return classMap[wishList] || "";
    } else {
      return "";
    }
  }
  indexofmaxArray: any;

  close(clg: any) {
    this.showPopup = false;

    const indexofmaxArray = this.maxUniversityListArr.findIndex(
      (college) => college?.ipedsId === clg?.dropDownData?.ipedsId
    );

    if (indexofmaxArray !== -1) {
      // Check if the property is defined before assignment
      if (this.maxUniversityListArr[indexofmaxArray]) {
        this.maxUniversityListArr[indexofmaxArray].wishList = "thclose";
      }

      // Optionally, return the computed value
      console.log(
        this.maxUniversityListArr[indexofmaxArray]?.wishList,
        "wishList"
      );
    }
  }

  // @HostListener("document:click", ["$event"])
  // onDocumentClick(event: Event) {
  //   // Iterate through the universityList and close popups for items that are not clicked
  //   this.universityList.forEach((college, index) => {
  //     const element = this.elem.nativeElement.querySelector(
  //       `.your-button-class-${index}`
  //     );

  //     if (element && element.contains(event.target as Node)) {
  //       // Clicked on the button for this specific item
  //       college.showPopup = !college.showPopup;
  //       this.selectedCollegeIndex = college.showPopup ? index : null;
  //     } else {
  //       // Clicked outside the button for this specific item
  //       college.showPopup = false;
  //     }
  //   });
  // }

  // @HostListener("document:click", ["$event"])
  // onDocumentClick(event: Event) {
  //   // Check if the click is outside the ng-container
  //   const containerElement = this.elem.nativeElement.querySelector(
  //     ".your-container-class"
  //   );

  //   // Check if the container element exists before proceeding
  //   if (containerElement) {
  //     // Check if the click is on the heart icon or inside the container
  //     const heartIcon =
  //       this.elem.nativeElement.querySelector(".heart-icon-class");

  //     // Check if the heartIcon element exists before proceeding
  //     if (
  //       heartIcon &&
  //       !containerElement.contains(event.target as Node) &&
  //       !heartIcon.contains(event.target as Node)
  //     ) {
  //       // Clicked outside the container and not on the heart icon, close the content
  //       this.selectedCollegeIndex = null;
  //     }
  //   }
  // }
  getOutOfPocketAmountMinusAdd(college: any) {}
}
